﻿/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this,
        dataset = slideshow.dataset;

      this.applyExperimentSlideFilter(slideshow);

      let dots = dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = dataset.autoplay == 'false' ? false : parseInt(dataset.autoplay, 10),
        align = dataset.align == 'center' ? 'center' : 'left',
        fade = dataset.fade == 'true' ? true : false,
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        custom_dots = slideshow.querySelector('.flickity-page-dots'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        isMainSlideshow = slideshow.classList.contains('main-slideshow'),
        isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent),
        isMobile = window.matchMedia('(max-width: 767px)').matches,
        shouldAnimate = animations_enabled && !(isMainSlideshow && isIOS && isMobile);

      this.hydrateHostedVideos();
      const hostedVideoBreakpoint = window.matchMedia('(max-width: 767px)');
      hostedVideoBreakpoint.addEventListener('change', () => {
        slideshow.hydrateHostedVideos();
      });

      if (slideshow_slides.length <= 1) {
        dots = false;
        autoplay = false;
        dataset.dots = 'false';
      }

      if (slideshow_slides.length < 1) return;
      // Avoid Flickity wrapAround clones flashing on 2-slide main slideshow.
      const wrapAround = !(isMainSlideshow && slideshow_slides.length <= 2);
      const args = {
        wrapAround: wrapAround,
        cellAlign: align,
        pageDots: false,
        contain: true,
        fade: fade,
        autoPlay: autoplay,
        rightToLeft: rightToLeft,
        prevNextButtons: false,
        cellSelector: '.carousel__slide',
        on: {}
      };


      if (slideshow.classList.contains('image-with-text-slideshow__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow__content'),
          image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow__image-media');
        args.draggable = false;
        args.asNavFor = main_slideshow;

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('customer-reviews__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.customer-reviews__content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow__content') ||
        slideshow.classList.contains('testimonials__carousel') ||
        slideshow.classList.contains('customer-reviews__content') ||
        slideshow.classList.contains('customer-reviews__image')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('custom-dots')) {

        if (shouldAnimate && isMainSlideshow) {
          this.prepareAnimations(slideshow, animations);
        }
        args.pauseAutoPlayOnHover = false;

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;
            const getBaseMobileHeight = () => {
              if (slideshow.classList.contains('mobile-height-full')) {
                const rootStyles = window.getComputedStyle(document.documentElement);
                const announcementHeight = parseFloat(rootStyles.getPropertyValue('--announcement-height') || 0) || 0;
                const viewportHeight = window.visualViewport?.height || window.innerHeight || 0;
                return Math.max(0, Math.round(viewportHeight - announcementHeight));
              }
              if (slideshow.classList.contains('mobile-height-500')) return 500;
              if (slideshow.classList.contains('mobile-height-450')) return 450;
              if (slideshow.classList.contains('mobile-height-400')) return 400;
              if (slideshow.classList.contains('mobile-height-350')) return 350;

              const slideshowStyles = window.getComputedStyle(slideshow);
              return parseFloat(slideshowStyles.minHeight || 0) || 0;
            };
            const scheduleResize = () => {
              requestAnimationFrame(() => {
                flkty.resize();
              });
            };
            const lockMobileHeight = () => {
              if (!isMainSlideshow || !isIOS || !window.matchMedia('(max-width: 767px)').matches) return;
              const viewport = slideshow.querySelector('.flickity-viewport');
              const slider = slideshow.querySelector('.flickity-slider');
              if (!viewport) return;
              const measure = () => {
                const baseMinHeight = getBaseMobileHeight();
                if (baseMinHeight > 0) {
                  viewport.style.minHeight = `${baseMinHeight}px`;
                  slideshow.style.minHeight = `${baseMinHeight}px`;
                  viewport.style.height = `${baseMinHeight}px`;
                  if (slider) {
                    slider.style.height = `${baseMinHeight}px`;
                  }
                  slideshow_slides.forEach((slide) => {
                    slide.style.height = `${baseMinHeight}px`;
                  });
                }
              };
              const schedule = () => requestAnimationFrame(measure);
              schedule();
              window.addEventListener('resize', schedule, { passive: true });
              slideshow.addEventListener('lazyloaded', schedule, { passive: true });
              document.fonts.ready.then(schedule);
              if ('ResizeObserver' in window) {
                const observer = new ResizeObserver(schedule);
                observer.observe(slideshow);
                observer.observe(viewport);
                if (slider) {
                  observer.observe(slider);
                }
              }
            };
            // Animations.
            if (shouldAnimate && isMainSlideshow) {
              slideshow.animateSlides(0, animations);
              gsap.set(slideshow.querySelectorAll('.subheading,.split-text,.button'), { visibility: 'visible' });
            } else if (isMainSlideshow) {
              slideshow.querySelectorAll('.subheading,.split-text,.button').forEach((el) => {
                el.style.visibility = 'visible';
              });
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', (e) => {
                  flkty.select(i);
                });
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }
            document.fonts.ready.then(scheduleResize);
            window.addEventListener('load', scheduleResize, { once: true });
            slideshow.addEventListener('lazyloaded', scheduleResize, { passive: true });
            lockMobileHeight();
            window.addEventListener('load', lockMobileHeight, { once: true });

            // Video Support.
            let video_containers = flkty.cells[0].element.querySelectorAll('.slideshow__slide-video-bg');
            video_containers.forEach((video_container) => {
              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  if (video_container.offsetParent !== null) {
                    slideshow.videoPlay(video_container);
                  }
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  if (video_container.offsetParent !== null) {
                    slideshow.videoPlay(video_container);
                  }
                };
              }
            });
          },
          change: function (index) {
            flkty.cells[0].element.classList.remove('is-initial-selected');
            let previousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length),
              nextIndex = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
            if (isMainSlideshow && window.matchMedia('(max-width: 767px)').matches) {
              const baseMinHeight = getBaseMobileHeight();
              const current = Math.max(slideshow.offsetHeight || 0, baseMinHeight);
              const existing = parseFloat(slideshow.style.minHeight || 0) || 0;
              if (current > existing) {
                slideshow.style.minHeight = `${current}px`;
              }
            }

            // Animations.
            if (shouldAnimate && isMainSlideshow) {
              setTimeout(() => {
                slideshow.animateReverse(previousIndex, animations);
              }, 300);
              slideshow.animateSlides(index, animations);
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.classList.remove('is-selected');
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }

            // AutoPlay
            if (autoplay) {
              this.stopPlayer();
              this.playPlayer();
            }

            // Video Support.
            // previous slide
            let video_containers_prev = flkty.cells[previousIndex].element.querySelectorAll('.slideshow__slide-video-bg');
            video_containers_prev.forEach((video_container) => slideshow.videoPause(video_container));
            // next slide
            let video_containers_next = flkty.cells[nextIndex].element.querySelectorAll('.slideshow__slide-video-bg');
            video_containers_next.forEach((video_container) => slideshow.videoPause(video_container));
            // current slide
            let video_containers = flkty.cells[index].element.querySelectorAll('.slideshow__slide-video-bg');
            video_containers.forEach((video_container) => {
              if (video_container.offsetParent === null) {
                slideshow.videoPause(video_container);
                return;
              }
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            });

          }
        };
      }
      if (slideshow.classList.contains('shoppable-video-reels--carousel')) {
        args.on.staticClick = function (event, pointer, cellElement, cellIndex) {
          if (typeof cellIndex == 'number') {
            flkty.select(cellIndex);
          }
        };
      }
      if (isMainSlideshow) {
        args.imagesLoaded = true;
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (!isMobile && (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image'))) {
          args.adaptiveHeight = true;
        } else if (isMobile) {
          args.adaptiveHeight = false;
        }
      }
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize', function () {
              slideshow.centerArrows(flickity, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize'));
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));

          progress_bar.style.width = progress * 100 + '%';

        };
      }
      const flkty = new Flickity(slideshow, args);

      slideshow.dataset.initiated = true;

      const syncPrevNextState = () => {
        if (!prev_button || !next_button) return;
        if (flkty.options.wrapAround) {
          prev_button.classList.remove('is-disabled');
          next_button.classList.remove('is-disabled');
          prev_button.removeAttribute('aria-disabled');
          next_button.removeAttribute('aria-disabled');
          prev_button.removeAttribute('tabindex');
          next_button.removeAttribute('tabindex');
          return;
        }

        const currentSlide = flkty.selectedSlide || flkty.slides[flkty.selectedIndex] || null;
        const prevSlide = flkty.slides[flkty.selectedIndex - 1] || null;
        const nextSlide = flkty.slides[flkty.selectedIndex + 1] || null;
        const currentTarget = currentSlide && typeof currentSlide.target === 'number' ? currentSlide.target : null;
        const prevTarget = prevSlide && typeof prevSlide.target === 'number' ? prevSlide.target : null;
        const nextTarget = nextSlide && typeof nextSlide.target === 'number' ? nextSlide.target : null;
        const epsilon = 0.5;

        const isPrevDisabled = !prevSlide || (currentTarget !== null && prevTarget !== null && Math.abs(prevTarget - currentTarget) <= epsilon);
        const isNextDisabled = !nextSlide || (currentTarget !== null && nextTarget !== null && Math.abs(nextTarget - currentTarget) <= epsilon);

        prev_button.classList.toggle('is-disabled', isPrevDisabled);
        next_button.classList.toggle('is-disabled', isNextDisabled);
        prev_button.setAttribute('aria-disabled', isPrevDisabled ? 'true' : 'false');
        next_button.setAttribute('aria-disabled', isNextDisabled ? 'true' : 'false');
        prev_button.setAttribute('tabindex', isPrevDisabled ? '-1' : '0');
        next_button.setAttribute('tabindex', isNextDisabled ? '-1' : '0');
      };


      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          if (prev_button.classList.contains('is-disabled')) return;
          flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          if (prev_button.classList.contains('is-disabled')) return;
          flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          if (next_button.classList.contains('is-disabled')) return;
          flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          if (next_button.classList.contains('is-disabled')) return;
          flkty.next();
        });
        syncPrevNextState();
        flkty.on('change', syncPrevNextState);
        flkty.on('settle', syncPrevNextState);
        flkty.on('ready', syncPrevNextState);
      }
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    getExperimentVariant() {
      const normalizeVariant = (value) => {
        const normalized = String(value || '').trim().toLowerCase();
        if (!normalized) return '';

        if (['control', 'variant-control', 'slideshow-control'].includes(normalized)) {
          return 'control';
        }
        if (['test1', 'test-1', 'variant1', 'variant-1', 'test_variant_1', 'test-variant-1', 'slideshow-test-1'].includes(normalized)) {
          return 'test1';
        }
        if (['test2', 'test-2', 'variant2', 'variant-2', 'test_variant_2', 'test-variant-2', 'slideshow-test-2'].includes(normalized)) {
          return 'test2';
        }
        return '';
      };

      const getCookieValue = (name) => {
        const pattern = `; ${document.cookie}`;
        const parts = pattern.split(`; ${name}=`);
        if (parts.length < 2) return '';
        return parts.pop().split(';').shift() || '';
      };

      const windowCandidates = [
        window.FCTSlideshowVariant,
        window.slideshowVariant,
        window.FCTABTests?.slideshowVariant,
        window.FCTExperiments?.slideshowVariant,
        window.ABTestData?.slideshowVariant
      ];

      for (const candidate of windowCandidates) {
        const normalized = normalizeVariant(candidate);
        if (normalized) return normalized;
      }

      const cookieCandidates = [
        'fct_slideshow_variant',
        'slideshow_variant',
        'fct_ab_slideshow_variant'
      ];

      for (const cookieName of cookieCandidates) {
        const normalized = normalizeVariant(getCookieValue(cookieName));
        if (normalized) return normalized;
      }

      return 'control';
    }
    applyExperimentSlideFilter(slideshow) {
      if (!slideshow.classList.contains('main-slideshow')) return;

      const slides = Array.from(slideshow.querySelectorAll('.carousel__slide'));
      const variant = this.getExperimentVariant();
      if (!variant) return;

      let allowed = null;

      if (variant === 'control') {
        const hiddenIndexes = String(slideshow.dataset.hideSlides || '')
          .split(',')
          .map((value) => String(value || '').trim())
          .filter(Boolean);

        if (hiddenIndexes.length < 1) return;

        const hiddenSet = new Set(hiddenIndexes);
        allowed = slides
          .map((slide) => slide.getAttribute('data-slide-index') || '')
          .filter((slideIndex) => slideIndex && !hiddenSet.has(slideIndex));
      } else {
        const visibleIndexesByVariant = {
          test1: [2],
          test2: [3]
        };

        const visibleIndexes = visibleIndexesByVariant[variant];
        if (!visibleIndexes) return;
        allowed = visibleIndexes.map((index) => String(index));
      }

      const allowedSet = new Set(allowed);
      const hasMatchingSlide = slides.some((slide) => {
        const slideIndex = slide.getAttribute('data-slide-index') || '';
        return allowedSet.has(slideIndex);
      });
      if (!hasMatchingSlide) return;

      slides.forEach((slide) => {
        const slideIndex = slide.getAttribute('data-slide-index') || '';
        if (!allowedSet.has(slideIndex)) {
          slide.remove();
        }
      });

      const visibleSlides = Array.from(slideshow.querySelectorAll('.carousel__slide'));
      if (visibleSlides.length < 1) return;
      visibleSlides.forEach((slide, index) => {
        slide.classList.toggle('is-initial-selected', index === 0);
      });

      const dotsContainer = slideshow.querySelector('.flickity-page-dots');
      if (!dotsContainer) return;

      if (visibleSlides.length <= 1) {
        dotsContainer.remove();
        slideshow.dataset.dots = 'false';
        return;
      }

      const dotTemplate = dotsContainer.querySelector('.dot');
      if (!dotTemplate) return;

      dotsContainer.innerHTML = '';
      visibleSlides.forEach((slide, index) => {
        const dot = dotTemplate.cloneNode(true);
        dot.classList.remove('is-selected');
        dot.setAttribute('aria-label', `${index + 1}`);
        dotsContainer.appendChild(dot);
      });
      slideshow.dataset.dots = 'true';
    }
    videoPause(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video')?.pause();
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video')?.play();
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "play"
          }), "*");
        }
      }, 10);
    }
    hydrateHostedVideos() {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      this.querySelectorAll('[data-video-template]').forEach((container) => {
        const variant = isMobile && container.querySelector('[data-video-mobile]') ? 'mobile' : 'desktop';
        if (container.dataset.videoVariant === variant) return;

        container.querySelector('video')?.pause();
        container.querySelector('[data-active-video]')?.remove();

        const template = container.querySelector(`[data-video-${variant}]`);
        if (!template) return;

        const video = template.content.firstElementChild.cloneNode(true);
        video.setAttribute('data-active-video', '');
        container.dataset.videoId = template.dataset.videoId;
        container.dataset.videoVariant = variant;
        container.appendChild(video);

        if (container.closest('.is-selected')) {
          video.play().catch(() => {});
        }
      });
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        new SplitText(slideshow.querySelectorAll('.split-text'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });
        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
            paused: true
          }),
            button_offset = 0;

          animations[i] = tl;

          if (slideshow.dataset.transition == 'swipe') {
            tl
              .fromTo(item, {
                clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)'
              }, {
                duration: 0.7,
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)"
              }, "start");
          }
          tl
            .to(item.querySelector('.slideshow__slide-bg'), {
              duration: 1.5,
              scale: 1
            }, "start");

          if (item.querySelector('.subheading')) {
            tl
              .to(item.querySelector('.subheading'), {
                duration: 0.5,
                autoAlpha: 1
              }, 0);

            button_offset += 0.5;
          }
          if (item.querySelector('.slideshow__slide-content--heading')) {
            let h1_duration = 0.5 + ((item.querySelectorAll('.slideshow__slide-content--heading .line-child div').length - 1) * 0.05);
            tl
              .from(item.querySelectorAll('.slideshow__slide-content--heading .line-child div'), {
                duration: h1_duration,
                yPercent: '100',
                stagger: 0.05
              }, 0);
            button_offset += h1_duration;
          }
          if (item.querySelector('p:not(.subheading)')) {

            let p_duration = 0.5 + ((item.querySelectorAll('p:not(.subheading) .line-child div').length - 1) * 0.02);
            tl
              .from(item.querySelectorAll('p:not(.subheading) .line-child div'), {
                duration: p_duration,
                yPercent: '100',
                stagger: 0.02
              }, 0);
            button_offset += p_duration;
          }
          if (item.querySelectorAll('.button')) {
            tl
              .fromTo(item.querySelectorAll('.button'), {
                y: '100%'
              }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });
        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, animations) {
      if (!animations || !animations[i]) return;
      const run = () => {
        animations[i].timeScale(1).restart();
      };
      if (!document.fonts || !document.fonts.ready) {
        run();
        return;
      }
      let done = false;
      const timer = setTimeout(() => {
        if (done) return;
        done = true;
        run();
      }, 500);
      document.fonts.ready.then(() => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        run();
      }).catch(() => {
        if (done) return;
        done = true;
        run();
      });
    }
    animateReverse(i, animations) {
      animations[i].timeScale(3).reverse();
    }
    centerArrows(flickity, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,

        image_height = first_cell.element.querySelector('.product-card--featured-image')?.clientHeight || 0;

      flickity.cells.forEach((item, i) => {
        if (item.size.height > max_height) {
          max_height = item.size.height;
        }
      });


      if (max_height > image_height) {
        let difference = (max_height - image_height) / -2;

        prev_button.style.transform = 'translateY(' + difference + 'px)';
        next_button.style.transform = 'translateY(' + difference + 'px)';
      }
    }
  }
  customElements.define('slide-show', SlideShow);
}
